import React, { useContext, useState } from "react";
import NumberFormat from "react-number-format";

import { MakeTailoringContext } from "../../context/MakeTailoringContext";
import PaymentModal from "../../Pages/PaymentModal";
import { ButtonContainer } from "../Shared/ButtonComponent";

const ItemDetails = ({ styleName, description }) => {
  const [paymentModal, setPaymentModal] = useState(false);

  const {
    tailoringQty,
    setTailoringQty,
    tailoringFormik: formik,
  } = useContext(MakeTailoringContext);

  

  const checkoutItem = JSON.parse(localStorage.getItem("checkoutItem"));

  const handleMakeOrder = () => {
    formik.handleSubmit("090");
    // localStorage.removeItem("checkoutItem")
  };

  const handleDecrement = () => {
    if (tailoringQty > 0) {
      setTailoringQty((prev) => prev - 1);
    }
  };
  return (
    <div className="item_details">
      <div>
        <p>{styleName}</p>
        <p>{description}</p>
        <p className="quan_p">
          <span>Quantity:</span>

          <button
            style={{
              backgroundColor: "#C7AB62",
              marginRight: "6px",
              border: "none",
            }}
            onClick={handleDecrement}
          >
            <i className="fa-solid fa-minus"></i>
          </button>
          <span className="fw-bold">{tailoringQty}</span>
          <button
            style={{
              backgroundColor: "#C7AB62",
              marginLeft: "6px",
              border: "none",
            }}
            onClick={() => {
              console.log("hey");
              setTailoringQty((prev) => prev + 1);
            }}
          >
            <i className="fa-solid fa-plus"></i>
          </button>
        </p>
      </div>

      <div>
        <p>
          <span className="outfit">Outfit Price:</span>

          <NumberFormat
            value={checkoutItem?.tailoring_price * tailoringQty}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"₦"}
          />
        </p>
        <p>
          <span className="delivery">Delivery:</span>
          <span>{checkoutItem?.delivery_fee}</span>
        </p>
        <p>
          <span className="total">Total:</span>
          {}
          <span>
            {" "}
            <NumberFormat
              value={
                checkoutItem?.tailoring_price * tailoringQty +
                checkoutItem?.delivery_fee
              }
              displayType={"text"}
              thousandSeparator={true}
              prefix={"₦"}
            />
          </span>
        </p>
      </div>
      <ButtonContainer
        onClick={() => {
          handleMakeOrder();
        }}
      >
        Proceed to Pay{" "}
        <NumberFormat
          value={
            checkoutItem?.tailoring_price * tailoringQty +
            checkoutItem?.delivery_fee
          }
          displayType={"text"}
          thousandSeparator={true}
          prefix={"₦"}
        />
      </ButtonContainer>

      <PaymentModal {...{ paymentModal, setPaymentModal }} />
    </div>
  );
};

export default ItemDetails;
